import React, { Component } from "react";
import { Link } from "react-router";
import { Button, Input, PasswordInput, Select, Messages } from "../components/ui";
import LandingHeader from "../components/layout/LandingHeader";
import LandingFooter from "../components/layout/LandingFooter";
import NewAcconunt from "../components/NewAcconunt";
import GoogleAuth from "../components/GoogleAuth";
import AuthService from "../services/AuthService";

class Login extends Component {
    constructor() {
        super();
        this.state = {
            senha: "",
            email: "",
            tipo_usuario: { name: 'Corredor' },
            loading: false,
            recaptchaChecked: false,
        };
        this.msg = React.createRef();
        this.authService = new AuthService();
    }

    handleLogin = async (e) => {
        e.preventDefault();
        if (this.state.loading) return;
        
        const tipoUser = this.state.tipo_usuario ? this.state.tipo_usuario.name : 'Corredor';
        
        this.setState({ loading: true });
        this.showMessage('info', 'Aguarde', 'Validando suas credenciais...');
        let data = {
            'email': this.state.email,
            'password': this.state.senha,
            'tipo_usuario': tipoUser
        };

        try {
            await this.authService.setLogin(JSON.stringify(data)).then(res => {
                if (!res.ok) throw new Error(res.status);
                else return res.json();
            }).then(data => this.handleSetCredentials(data))
                .catch((error) => {
                    this.showMessage('error', 'Erro!', 'Usuário ou senha inválidos!');
                    this.setState({ loading: false });
                });
        }
        catch (err) {
            this.showMessage('error', 'Erro!', 'Usuário ou senha inválidos!');
            this.setState({ loading: false });
        }
    }

    showMessage = (severity, summary, detail) => {
        if (!this.msg.current) return;
        this.msg.current.clear();
        this.msg.current.show([{ severity, summary, detail }]);
    }

    handleSetCredentials(data) {
        sessionStorage.setItem('brv-user-token', data.token);
        sessionStorage.setItem('brv-user', data.first_name);
        sessionStorage.setItem('brv-user-id', data.user_id);
        sessionStorage.setItem('brv-tipo-user', data.tipo_usuario);
        this.showMessage('success', 'Sucesso!', 'Login realizado com sucesso!');
        const tipoUserNormalized = String(data.tipo_usuario || '').toLowerCase();
        const redirectPath = tipoUserNormalized.includes('staff')
            ? '/staff-dashboard'
            : data.tipo_usuario === 'Organizador'
                ? '/dashboard'
                : data.tipo_usuario === 'Corredor'
                    ? '/minhas-corridas'
                    : null;
        if (redirectPath) {
            setTimeout(() => window.location.replace(redirectPath), 500);
        } else {
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        document.body.classList.add('bg-login');
    }

    componentWillUnmount() {
        document.body.classList.remove('bg-login');
    }

    render() {
        return (
            <div className="landing-page-wrapper min-h-screen flex flex-col justify-between bg-urb-dark-login">
                {/* Header Navigation */}
                <LandingHeader />

                {/* Main Content Area */}
                <main className="flex-1 flex flex-col items-center justify-center py-10 px-4">
                    {/* Header Title */}
                    <div className="text-center mb-6">
                        <h1 className="text-4xl md:text-5xl font-black tracking-tight uppercase m-0 flex items-center justify-center gap-1.5">
                            <span className="text-white">URB</span>
                            <span className="text-urb-primary">RACE</span>
                        </h1>
                        <p className="text-sm md:text-base mt-2 m-0 text-urb-text-secondary">
                            Acesse sua conta
                        </p>
                    </div>

                    {/* Login Card */}
                    <div className="w-full max-w-md rounded-2xl border border-urb-border p-6 sm:p-8 shadow-2xl bg-urb-card/85 backdrop-blur-md">
                        <Messages ref={this.msg} />

                        {/* Google Auth */}
                        <GoogleAuth />

                        {/* Divider 'ou' */}
                        <div className="flex items-center my-5">
                            <div className="flex-1 border-b border-urb-border"></div>
                            <span className="px-3 text-xs uppercase tracking-wider text-urb-text-muted">ou</span>
                            <div className="flex-1 border-b border-urb-border"></div>
                        </div>

                        <form onSubmit={this.handleLogin} className="flex flex-col w-full">
                            {/* Email Input */}
                            <div className="flex flex-col gap-2 mb-4 w-full text-left">
                                <label htmlFor="email1" className="text-sm font-semibold text-white">Email</label>
                                <Input 
                                    id="email1" 
                                    type="email" 
                                    placeholder="Digite seu email" 
                                    value={this.state.email} 
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    required
                                />
                            </div>

                            {/* Password Input */}
                            <div className="flex flex-col gap-2 mb-2 w-full text-left">
                                <label htmlFor="password1" className="text-sm font-semibold text-white">Senha</label>
                                <PasswordInput 
                                    id="password1" 
                                    placeholder="Digite sua senha"
                                    value={this.state.senha} 
                                    onChange={(e) => this.setState({ senha: e.target.value })}
                                    required
                                />
                            </div>

                            {/* Tipo de Usuário Dropdown */}
                            <div className="flex flex-col gap-2 mb-4 w-full text-left">
                                <label htmlFor="tipo-usuario" className="text-sm font-semibold text-white">Tipo de Usuário</label>
                                <Select 
                                    id="tipo-usuario"
                                    value={this.state.tipo_usuario} 
                                    onChange={(e) => this.setState({ tipo_usuario: e.value })} 
                                    options={[
                                        { name: 'Corredor' },
                                        { name: 'Organizador' },
                                        { name: 'staff_urbrace' }
                                    ]}
                                    optionLabel="name" 
                                    placeholder="Selecione o tipo de usuário" 
                                />
                            </div>

                            {/* Forgot Password Link */}
                            <div className="flex justify-end mb-5">
                                <Link
                                    to="/solicitar-recuperacao"
                                    className="text-xs font-medium text-urb-primary hover:underline transition-colors"
                                >
                                    Esqueceu sua senha?
                                </Link>
                            </div>

                            {/* reCAPTCHA Box */}
                            <div className="flex justify-center mb-5">
                                <div className="flex items-center justify-between p-3 rounded-lg border border-urb-border w-full max-w-[300px] bg-[#181A20]">
                                    <div className="flex items-center gap-3">
                                        <input 
                                            type="checkbox" 
                                            id="recaptchaCheck" 
                                            checked={this.state.recaptchaChecked} 
                                            onChange={(e) => this.setState({ recaptchaChecked: e.target.checked })} 
                                            className="w-5 h-5 accent-[#8AE600] cursor-pointer"
                                        />
                                        <label htmlFor="recaptchaCheck" className="text-xs text-white cursor-pointer select-none">
                                            Não sou um robô
                                        </label>
                                    </div>
                                    <div className="flex flex-col items-center gap-0.5 opacity-80 scale-90">
                                        <img src="https://www.gstatic.com/recaptcha/api2/logo_48.png" alt="reCAPTCHA" width="28" height="28" />
                                        <span className="text-[9px] text-urb-text-secondary leading-none">reCAPTCHA</span>
                                        <span className="text-[8px] text-urb-text-muted leading-none">Privacidade - Termos</span>
                                    </div>
                                </div>
                            </div>

                            {/* ENTRAR Button */}
                            <Button 
                                type="submit" 
                                label="ENTRAR" 
                                variant="primary"
                                size="lg"
                                className="w-full tracking-wider uppercase mb-2 shadow-lg"
                                loading={this.state.loading} 
                                disabled={this.state.loading} 
                            />

                            {/* Sign Up Link */}
                            <NewAcconunt />
                        </form>
                    </div>
                </main>

                {/* Footer */}
                <LandingFooter />
            </div>
        );
    }
}

export default Login;
